/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Status_StartingInputs */

const en_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting sync process... please wait.`)
};

const fr_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage du processus de synchronisation... veuillez patienter.`)
};

const de_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierungsvorgang wird gestartet... Bitte warten.`)
};

const it_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio del processo di sincronizzazione... attendere.`)
};

const ru_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинается процесс синхронизации... пожалуйста, подождите.`)
};

const es_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando proceso de sincronización... por favor espere.`)
};

const zh_cn2_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在启动同步过程……请稍候。`)
};

const ja_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期プロセスを開始しています...お待ちください。`)
};

const hi_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सिंक्रोनाइज़ेशन प्रक्रिया शुरू हो रही है... कृपया प्रतीक्षा करें।`)
};

const pt_pt2_sync_changes_status_starting = /** @type {(inputs: Sync_Changes_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando o processo de sincronização... aguarde.`)
};

/**
* | output |
* | --- |
* | "Starting sync process... please wait." |
*
* @param {Sync_Changes_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_status_starting = /** @type {((inputs?: Sync_Changes_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_status_starting(inputs)
	if (locale === "de") return de_sync_changes_status_starting(inputs)
	if (locale === "it") return it_sync_changes_status_starting(inputs)
	if (locale === "ru") return ru_sync_changes_status_starting(inputs)
	if (locale === "es") return es_sync_changes_status_starting(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_status_starting(inputs)
	if (locale === "ja") return ja_sync_changes_status_starting(inputs)
	if (locale === "hi") return hi_sync_changes_status_starting(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_status_starting(inputs)
	return en_sync_changes_status_starting(inputs)
});